import React, { useRef, useState } from "react";
import { Alert, Box, FormControlLabel, Paper, Switch, Typography } from "@mui/material";
import axiosInstance from "../axiosInstance";

export default function NightlyProductUpdateToggle({ tenantId, value, onSaved, onSavingChange, disabled = false }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const requestPending = useRef(false);
  const checked = value === true || String(value).toLowerCase() === "true";

  const updateNightlyJob = async (isActive) => {
    if (!tenantId || disabled || requestPending.current) return;
    requestPending.current = true;
    setSaving(true);
    onSavingChange?.(true);
    setError(null);
    try {
      await axiosInstance.post(`/tenant/${tenantId}/update-nightly-product-job-settings`, { isActive });
      onSaved(tenantId, isActive);
    } catch (requestError) {
      setError(requestError.response?.data?.message || "Could not update the nightly job. Please try again.");
    } finally {
      requestPending.current = false;
      setSaving(false);
      onSavingChange?.(false);
    }
  };

  return (
    <Paper elevation={0} sx={{ p: 1.5, borderRadius: "18px", border: "1px solid rgba(255, 132, 76, 0.10)", backgroundColor: "rgba(255,255,255,0.86)", height: "100%" }}>
      <FormControlLabel
        sx={{ m: 0, width: "100%", alignItems: "flex-start" }}
        control={<Switch checked={checked} disabled={!tenantId || disabled || saving} onChange={(event) => updateNightlyJob(event.target.checked)} color="warning" />}
        label={
          <Box sx={{ pr: 1 }}>
            <Typography sx={{ fontWeight: 700, color: "#202531" }}>Include in Nightly Update ({checked ? "ON" : "OFF"})</Typography>
            <Typography variant="body2" sx={{ color: "#6b7280", mt: 0.3 }} aria-live="polite">
              {saving ? "Updating nightly job..." : "Changes are saved immediately."}
            </Typography>
          </Box>
        }
      />
      {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
    </Paper>
  );
}
